import { elakay_API } from "../../config";
import { isAuthenticated } from "./index";

// My Profile self-service edits (PATCH /user/profile): { firstname?,
// lastname?, languageCode? } only -- the backend refuses any other field
// (email, roles...). Resolves { success, user: { firstname, lastname,
// email, language } } with the values actually stored.
export const updateMyProfileAPI = async (changes, token = isAuthenticated()?.token) => {
  const response = await fetch(`${elakay_API}/user/profile`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(changes),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data?.error || `Error ${response.status}`);
    error.status = response.status;
    error.code = data?.code;
    throw error;
  }
  return data;
};
